var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 5.36182H1.66667C1.29848 5.36182 1 5.66029 1 6.02848V8.69515C1 9.06334 1.29848 9.36182 1.66667 9.36182H16.3333C16.7015 9.36182 17 9.06334 17 8.69515V6.02848C17 5.66029 16.7015 5.36182 16.3333 5.36182Z",
    stroke: "#727476",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6668 9.36182V15.3618C15.6668 15.5386 15.5966 15.7082 15.4716 15.8332C15.3465 15.9582 15.177 16.0285 15.0002 16.0285H3.00016C2.82335 16.0285 2.65378 15.9582 2.52876 15.8332C2.40373 15.7082 2.3335 15.5386 2.3335 15.3618V9.36182",
    stroke: "#727476",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.36182V16.0285",
    stroke: "#727476",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.775 4.42014C11.825 5.3618 9 5.3618 9 5.3618C9 5.3618 9 2.5368 9.94167 1.5868C10.3174 1.21108 10.827 1 11.3583 1C11.8897 1 12.3993 1.21108 12.775 1.5868C13.1507 1.96253 13.3618 2.47212 13.3618 3.00347C13.3618 3.53482 13.1507 4.04441 12.775 4.42014V4.42014Z",
    stroke: "#727476",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22499 4.42014C6.17499 5.3618 8.99999 5.3618 8.99999 5.3618C8.99999 5.3618 8.99999 2.5368 8.05832 1.5868C7.6826 1.21108 7.17301 1 6.64165 1C6.1103 1 5.60071 1.21108 5.22499 1.5868C4.84926 1.96253 4.63818 2.47212 4.63818 3.00347C4.63818 3.53482 4.84926 4.04441 5.22499 4.42014V4.42014Z",
    stroke: "#727476",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItems);
export default __webpack_public_path__ + "static/media/no-items.d5307935e6b5d815817ead20e0bd08a7.svg";
export { ForwardRef as ReactComponent };